import React from "react";

import { BasicButton } from "@gaming/xds-react-js";

import * as commonStyles from "../../../components/commonStyles/commonStyles.module.css";
import { navigateToXboxCom } from "../helpers";
import { StreamingButtonLabels } from "../streamingEuContent";

export type StreamingEuCloseButtonProps = Readonly<{
  isPrimary?: boolean;
}>;

export const StreamingEuCloseButton = ({ isPrimary }: StreamingEuCloseButtonProps) => (
  <BasicButton
    as={"button"}
    onClick={navigateToXboxCom}
    className={isPrimary ? commonStyles.primaryButton : commonStyles.secondaryButton}
    textDecorationUnderline={true}
  >
    {StreamingButtonLabels.Close}
  </BasicButton>
);
